/**
 * Helpers for JPG tracking
 */
var Tracking = function() {

  const campaignName = 'le male - be the captain';

  // Track the number of people who start the game: it will give us feedbacks on the implementation of this type of game (screen 1)
  function startGame() {
    console.log(`Tracking::startGame()`);
    try {
      var interaction = {};
      interaction.campaign = {};
      interaction.campaign.name = campaignName;
      interaction.campaign.step = 'step 1';
      if (window.top.track) {
        window.top.track.push({
          event: 'campaignStart',
          interaction: interaction
        });
      }
    } catch (e) {
      console.log(`Tracking error`, e);
    }
  }

  // Track the number of people who reach each step (screens 2- 4)
  // We have added this extra event since it would also be interesting to know exactly at which step users abandon.
  function step(num) {
    console.log(`Tracking::step(${num})`);
    try {
      var interaction = {};
      interaction.campaign = {};
      interaction.campaign.name = campaignName;
      interaction.campaign.step = `step ${num + 1}`;
      if (window.top.track) {
        window.top.track.push({
          event: 'campaignInteraction',
          interaction: interaction
        });
      }
    } catch (e) {
      console.log(`Tracking error`, e);
    }
  }

  // Track the number of people who finish the game: allowing us to know the abandonment rate. (screen 5)
  function endGame() {
    console.log(`Tracking::endGame()`);
    try {
      var interaction = {};
      interaction.campaign = {};
      interaction.campaign.name = campaignName;
      interaction.campaign.step = 'step 5';
      if (window.top.track) {
        window.top.track.push({
          event: 'campaignEnd',
          interaction: interaction
        });
      }
    } catch (e) {
      console.log(`Tracking error`, e);
    }
  }

  // Track the number of people who are clicking in the 2 CTA : “Subscribe” and “discover the fragrance” (screen 5)
  function clickDiscover() {
    console.log(`Tracking::clickDiscover()`);
    try {
      var interaction = {};
      interaction.campaign = {};
      interaction.campaign.name = campaignName;
      interaction.campaign.step = 'step 5';
      interaction.campaign.clickCTA = 'discover the fragrance';
      if (window.top.track) {
        window.top.track.push({
          event: 'campaignInteraction',
          interaction: interaction
        });
      }
    } catch (e) {
      console.log(`Tracking error`, e);
    }
  }

  function clickSubscribe() {
    console.log(`Tracking::clickSubscribe()`);
    try {
      var interaction = {};
      interaction.campaign = {};
      interaction.campaign.name = campaignName;
      interaction.campaign.step = 'step 5';
      interaction.campaign.clickCTA = 'subscribe to the newsletter';
      if (window.top.track) {
        window.top.track.push({
          event: 'campaignInteraction',
          interaction: interaction
        });
      }
    } catch (e) {
      console.log(`Tracking error`, e);
    }
  }

  function clickShare(platform, shared_url) {
    console.log(`Tracking::clickShare(${platform})`, shared_url);
    try {
      var interaction = {};
      interaction.contentShare = {};
      interaction.contentShare.type = 'social';
      interaction.contentShare.socialNetworkID = platform; // 'twitter', 'facebook'
      interaction.contentShare.sharedLink = shared_url; // www.jeanpaulgaultier.com/it-it/profumo-ultra-male/;
      if (window.top.track) {
        window.top.track.push({
          event: 'contentShareClick',
          interaction: interaction
        });
      }
    } catch (e) {
      console.log(`Tracking error`, e);
    }
  }

	return {
    startGame,
    step,
    endGame,
    clickSubscribe,
    clickDiscover,
    clickShare
	}
};

export { Tracking as default };
